import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useEffect, useState } from 'react';
import { PolicyState } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { capitalize } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
export var PolicyStateViewTypeEnum;

(function (PolicyStateViewTypeEnum) {
  PolicyStateViewTypeEnum["quote"] = "quote";
  PolicyStateViewTypeEnum["cms"] = "cms";
  PolicyStateViewTypeEnum["validation"] = "validation";
})(PolicyStateViewTypeEnum || (PolicyStateViewTypeEnum = {}));

var PolicyStateView = function PolicyStateView(props) {
  var className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? PolicyStateViewTypeEnum.quote : _props$type,
      label = props.label,
      color = props.color,
      status = props.status;

  var _useState = useState({}),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];

  var _useState2 = useState(''),
      showText = _useState2[0],
      setShowText = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    evaluateTextInfo();
  }, [status]);
  /**
   * methods
   */

  var evaluateTextInfo = function evaluateTextInfo() {
    var textColor = color;
    var showText = label || '';

    if (!textColor) {
      switch (status) {
        case PolicyState.POLICY_CANCELLED:
        case PolicyState.POLICY_ERROR:
          textColor = '#DD1F1F';
          break;

        case PolicyState.POLICY_ELAPSED:
          textColor = '#999999';
          break;

        case PolicyState.POLICY_PAUSED:
          textColor = '#43A7D2';
          break;

        case PolicyState.POLICY_PENDING:
          textColor = '#E6C30C';
          break;

        default:
          textColor = '#1CB258';
          break;
      }
    }

    if (!label) {
      var _PolicyState$POLICY_A;

      showText = (_PolicyState$POLICY_A = {}, _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_ACTIVE, 'Active'), _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_CANCELLED, 'Cancelled'), _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_PENDING, 'Pending'), _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_PAUSED, 'Paused'), _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_ELAPSED, 'Elapsed'), _defineProperty(_PolicyState$POLICY_A, PolicyState.POLICY_ERROR, 'Error'), _PolicyState$POLICY_A)[status];

      if (!showText) {
        showText = status;
      }
    }

    setShowText(showText);
    setContainerStyle({
      borderColor: "".concat(textColor),
      color: "".concat(textColor)
    });
  };

  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    className: clsx('inline-flex flex-row rounded-lg border px-[8px] py-[6px] text-sm font-bold', className),
    children: capitalize(showText === null || showText === void 0 ? void 0 : showText.replaceAll('_', ' '))
  });
};

export default PolicyStateView;